import { Grid } from '@mui/material';
import { WbText } from '@workbench/react';
import Heading from '../../dataDisplay/Heading';

interface BeamLabelProps {
    getLabelGridSize: () => number;
    label?: string;
    subLabel?: string;
    required?: boolean;
}

const BeamSelectTextLabel = (props: BeamLabelProps) => {
    return (
        <Grid size={{ xs: props.getLabelGridSize() }}>
            {props.label && <Heading header={props.label} mandatory={props.required} />}
            {props.subLabel && <WbText>{props.subLabel}</WbText>}
        </Grid>
    );
};

export default BeamSelectTextLabel;
